import { render, staticRenderFns } from "./CollapsableSubSegment.vue?vue&type=template&id=238073c2"
import script from "./CollapsableSubSegment.vue?vue&type=script&lang=js"
export * from "./CollapsableSubSegment.vue?vue&type=script&lang=js"
import style0 from "./CollapsableSubSegment.vue?vue&type=style&index=0&id=238073c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports